<article
  class="t1-ev-card"
  [attr.data-status]="visualStatus"
  [attr.data-type]="isLeague ? 'league' : 'tournament'"
  role="button"
  tabindex="0"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  (keydown.space)="$event.preventDefault(); onCardClick()"
>
  <div class="t1-ev-card__media">
    <img [src]="image" [alt]="item.name" loading="lazy" />
  </div>

  <div class="t1-ev-card__body">
    <!-- Reference build phase 8b: the pill sits in the body, not stamped on the
         poster. It is still absolutely positioned over the media above the
         phone breakpoint - the card is the positioning context, so the move
         costs the desktop layout nothing. -->
    <span
      class="t1-ev-card__status"
      [ngClass]="'t1-ev-card__status--' + visualStatus"
      *ngIf="statusTitle"
    >
      {{ statusTitle | translate }}
    </span>

    <div class="t1-ev-card__head">
      <span class="t1-ev-card__type">{{ typeKey | translate }}</span>
      <time class="t1-ev-card__date">
        {{ item.event_start_date | date: 'MMMM dd, yyyy' }}
        <span class="t1-ev-card__date-sep" aria-hidden="true">–</span>
        {{ item.event_end_date | date: 'MMMM dd, yyyy' }}
      </time>
    </div>

    <h3 class="t1-ev-card__title" [title]="item.name">{{ item.name }}</h3>

    <ul class="t1-ev-card__stats">
      <li
        class="t1-ev-card__stat t1-ev-card__stat--location"
        *ngIf="location"
        [title]="location"
      >
        <span class="t1-ev-card__stat-text">{{ location }}</span>
      </li>
      <li class="t1-ev-card__stat t1-ev-card__stat--registered" *ngIf="!isBroadcastRoute">
        <button
          type="button"
          class="t1-ev-card__stat-btn"
          (click)="onViewRegisterCount($event)"
          (keydown.enter)="onViewRegisterCount($any($event))"
          (keydown.space)="$event.preventDefault(); onViewRegisterCount($any($event))"
        >
          {{ item.registered_participants || 0 }} {{ 'registered' | translate }}
        </button>
      </li>
    </ul>

    <div class="t1-ev-card__timer-slot">
      <div class="t1-ev-card__timer text-center" *ngIf="closesInKey">
        {{ closesInKey | translate: { count: closesInCount } }}
      </div>
    </div>

    <button
      type="button"
      class="t1-ev-card__cta"
      [ngClass]="isRegistrationOpen ? 't1-ev-card__cta--primary' : 't1-ev-card__cta--secondary'"
      (click)="onCtaClick($event)"
      (keydown.enter)="onCtaClick($any($event))"
      (keydown.space)="$event.preventDefault(); onCtaClick($any($event))"
    >
      {{ ctaKey | translate }}
    </button>
  </div>
</article>
